import { ServiceFetch } from '../service-fetch'

export default class FactPettyCashWithdrawalModel extends ServiceFetch {
    getFactPettyCashWithdrawalBy = (data) => this.authFetch({
        url: 'fact-petty-cash-withdrawal/getFactPettyCashWithdrawalBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}